import type { MiniAppDefinition } from '../types';

import { clinicalFindingsApp } from './clinical-findings';

/**
 * Explicit registry of all frontend mini-apps. Listed here (rather than via
 * side-effect registration) so tree-shaking can't drop an app. Add a new app by
 * importing its definition and appending it.
 */
export const ALL_MINI_APPS: readonly MiniAppDefinition[] = [
  clinicalFindingsApp,
  // labResultsApp — added when the lab app migrates onto the SDK.
];
